import { Component, OnInit, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserVerificationService } from '../../services/user-verification.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import swal from 'sweetalert2';
import { ModalDirective } from 'ngx-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
declare var $: any;


@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.css'],
  exportAs: 'otpModal'
})
export class OtpVerificationComponent implements OnInit, OnDestroy {
  @Input() resetData: any;
  @ViewChild('otpModal') public otpModal: ModalDirective;
  @Output() otpModalResponse = new EventEmitter<any>();
  @Output() verifiedChange = new EventEmitter<boolean>();


  otpVerificationForm: FormGroup;
  oneDigitRegex = '^(?:[0-9]|0[0-9]|10)$';
  verifyMobileStatus: string;

  private subscription: Subscription;
  constructor(
    private formBuilder: FormBuilder,
    private userVerificationService: UserVerificationService,
    private router: Router
  ) { }
  ngOnInit() {
    this.verifyMobileStatus = window.localStorage.getItem('verifyMobileStatus');
    this.createOTPForm();
  }
  showModal(confirm: boolean, verifyMobile?) {
    if (confirm && this.verifyMobileStatus !== 'later') {
      swal({
        title: "Mobile number verification",
        text: "Please take a moment to verify your mobile number. This help us confirm your identity and secure your account.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Verify",
        cancelButtonText: "Later",
        confirmButtonClass: "btn btn-sm adjust-swal-button",
        cancelButtonClass: "btn btn-sm adjust-swal-button",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.otpModalResponse.emit(result.value);
          this.sendOTP();
        } else {
          window.localStorage.setItem("verifyMobileStatus", "later");
          this.otpModalResponse.emit(result.value);
        }
      });
    }
     else if (this.verifyMobileStatus !== 'later') {
      this.sendOTP();
    }
    else if(verifyMobile) {
      this.sendOTP();
    }
  }

  sendOTP() {
    this.userVerificationService
      .sendOtp(this.resetData.email, this.resetData.otpMethod, 'resend-otp')
      .subscribe(
        (response: any) => {
        },
        error => {
        }
      );
    this.otpModal.show();
  }

  createOTPForm() {
    this.otpVerificationForm = this.formBuilder.group({
      digit1: [
        '',
        [Validators.required, Validators.pattern(this.oneDigitRegex)]
      ],
      digit2: [
        '',
        [Validators.required, Validators.pattern(this.oneDigitRegex)]
      ],
      digit3: [
        '',
        [Validators.required, Validators.pattern(this.oneDigitRegex)]
      ],
      digit4: [
        '',
        [Validators.required, Validators.pattern(this.oneDigitRegex)]
      ]
    });
  }

  validate(value: string, id: string, field: string, evt: any) {
    if (!this.otpVerificationForm.controls[field].hasError('pattern')) {
      if (evt.keyCode === 46 || evt.keyCode === 8 || evt.keyCode === 9) {
      }
      else {
        document.getElementById(id).focus();
      }
    }
  }

  resendOTP() {

    this.otpVerificationForm.reset();
    this.userVerificationService
      .sendOtp(this.resetData.email, this.resetData.otpMethod, 'resend-otp')
      .subscribe(
        (response: any) => {


          this.otpVerificationForm.reset();
          swal('Success', response, 'success');
        },
        error => {

          swal('Error', error.error.error.message, 'error');
          this.otpVerificationForm.reset();
        }
      );
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  submitOTP() {
    if (this.otpVerificationForm.valid) {
      const otp =
        this.otpVerificationForm.value.digit1 +
        this.otpVerificationForm.value.digit2 +
        this.otpVerificationForm.value.digit3 +
        this.otpVerificationForm.value.digit4;
      const email = this.resetData.email;
      this.userVerificationService
        .verifyUserByMobile(otp, this.resetData.email)
        .subscribe(
          (response: any) => { swal('Success', 'Mobile number has been verified', 'success');
            this.otpVerificationForm.reset();
            this.hideModal();

            this.verifiedChange.emit()
          },
          error => {

            swal('Error', error.error.error.message, 'error');
            this.otpVerificationForm.reset();
          }
        );
    }
  }
  hideModal() {
    this.otpModal.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/otp-verification/otp-verification.component.ts